import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';

import { IncomingToolRequestsComponent } from '@app/roles/kardex-operator/pages/incoming-tool-requests/incoming-tool-requests.component';
import { IncomingToolsReturnedComponent } from '@app/roles/kardex-operator/pages/incoming-tools-returned/incoming-tools-returned.component';
import { IncomingToolsTableComponent } from '@app/roles/kardex-operator/components/incoming-tools-table/incoming-tools-table.component';
import { ComponentsModule } from '@app/shared/components/components.module';
import { IncomingToolRequestsDetailComponent } from './pages/incoming-tool-requests-detail/incoming-tool-requests-detail.component';
import { IncomingToolsReturnedDetailComponent } from './pages/incoming-tools-returned-detail/incoming-tools-returned-detail.component';
import { ToolModule } from '@app/tool/tool.module';
import { ToolProcessingFilterBottomSheetComponent } from './components/tool-processing-bottom-sheet/tool-processing-filter-bottom-sheet.component';


@NgModule({
    declarations: [
        IncomingToolRequestsComponent,
        IncomingToolsReturnedComponent,
        IncomingToolsTableComponent,
        IncomingToolRequestsDetailComponent,
        IncomingToolsReturnedDetailComponent,
        ToolProcessingFilterBottomSheetComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        ComponentsModule,
        ToolModule,
    ],
    providers: [],
    bootstrap: []
})
export class KardexOperatorModule { }
